import styled from 'styled-components';
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
} from '../../Strategy/styles';

/**
 * Cabeçalho + card sem colapso de margem (soma o espaço como no /calc).
 * O gap replica margin-bottom do título + margin-top do card (~28+16 / ~36+24).
 */
export const DisciplineReportStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 44px;

    @media (min-width: 768px) {
        gap: 60px;
    }
`;

export const DisciplinePageHeader = styled(StrategyPageHeader)`
    margin-bottom: 0 !important;
`;

export const DisciplineWideCardColumn = styled(StrategyWideCardColumn)`
    margin-top: 0 !important;
`;

export const FilterSection = styled.div`
    margin-bottom: 8px;
`;

export const FilterTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(200, 210, 235, 0.9);
    margin-bottom: 16px;

    i {
        color: #f29205;
    }
`;

export const FilterRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;

    @media (min-width: 768px) {
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 16px 20px;
    }
`;

export const FilterField = styled.div`
    flex: 1;
    min-width: 0;
    width: 100%;

    .MuiFormControl-root {
        width: 100%;
    }

    @media (min-width: 768px) {
        flex: 1 1 200px;
        max-width: 280px;
        width: auto;
    }
`;

export const FilterActions = styled.div`
    width: 100%;
    display: flex;
    align-items: stretch;
    align-self: stretch;

    /* Mobile: mesma altura que Import CSV / Adicionar em /trading (44px) */
    .MuiButton-root {
        width: 100% !important;
        max-width: 100%;
        min-height: 44px !important;
        height: 44px !important;
        padding: 10px 18px !important;
        font-size: 14px !important;
        line-height: 1.25 !important;
        border-radius: 10px !important;
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    @media (min-width: 768px) {
        width: auto;
        flex: 0 0 auto;
        align-self: flex-end;

        .MuiButton-root {
            width: auto !important;
            max-width: none;
            min-height: 52px !important;
            height: 52px !important;
            padding: 0 22px !important;
            font-size: 14px !important;
        }
    }

    @media (min-width: 992px) {
        .MuiButton-root {
            min-height: 56px !important;
            height: 56px !important;
            font-size: 15px !important;
        }
    }
`;

export const ObservationsBox = styled.div`
    margin-top: 24px;
    padding: 18px 20px;
    border-radius: 12px;
    border: 1px solid rgba(0, 212, 255, 0.2);
    background: rgba(0, 212, 255, 0.06);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);

    .obs-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 700;
        color: #7dd3fc;
        margin-bottom: 12px;

        i {
            opacity: 0.9;
        }
    }

    .obs-text {
        font-size: 15px;
        line-height: 1.65;
        color: rgba(210, 220, 245, 0.9);
        margin: 0;

        p {
            margin: 0 0 10px 0;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
`;

export const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 28px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const GridItem = styled.div`
    min-width: 0;
`;

/** No breakpoint intermediário, nota ocupa linha inteira */
export const GridItemWide = styled.div`
    min-width: 0;

    @media (min-width: 768px) and (max-width: 1199px) {
        grid-column: 1 / -1;
    }
`;

export const AssessmentBody = styled.div`
    padding: 16px 18px 18px;
    text-align: center;
    font-size: 15px;
    line-height: 1.5;
    color: rgba(230, 235, 250, 0.95);
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0;
    min-height: 0;

    .assessment-highlight {
        display: block;
        margin-top: 12px;
        font-size: clamp(1.5rem, 4vw, 2rem);
        font-weight: 800;
        color: #ffc078;
        font-variant-numeric: tabular-nums;
        text-shadow: 0 0 24px rgba(242, 146, 5, 0.25);
    }

    .assessment-muted {
        color: rgba(180, 195, 230, 0.82);
        font-size: 15px;
    }
`;

export const AssessmentCaption = styled.p`
    margin: 0 0 14px;
    max-width: 28rem;
    font-size: 13px;
    line-height: 1.45;
    color: rgba(160, 170, 200, 0.88);
    font-weight: 500;

    @media (min-width: 768px) {
        font-size: 14px;
        margin-bottom: 16px;
    }
`;

export const AssessmentScoreRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: center;
    gap: 8px 10px;
    row-gap: 4px;
`;

export const AssessmentScoreIntro = styled.span`
    font-size: clamp(0.95rem, 2.2vw, 1.05rem);
    font-weight: 600;
    color: rgba(210, 218, 240, 0.92);
`;

export const AssessmentScoreNumber = styled.span`
    font-size: clamp(1.35rem, 4vw, 1.85rem);
    font-weight: 800;
    line-height: 1.2;
    color: #ffb347;
    font-variant-numeric: tabular-nums;
    text-shadow: 0 0 20px rgba(242, 146, 5, 0.35);
`;

export const AssessmentScoreOutro = styled.span`
    font-size: clamp(0.95rem, 2.2vw, 1.05rem);
    font-weight: 600;
    color: rgba(210, 218, 240, 0.92);
`;

export const PageInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }
`;

export const calcPrimaryButtonStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 22px',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: 14,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.35)',
    minWidth: 120,
    textTransform: 'none',
    transition: 'all 0.25s ease',
};
